import { Select } from '@opengov/component-library/dist';
import { IConditionalReportColumn } from '@opengov/reporting-types';
import { IReportColumn } from '@opengov/reporting-types/src/reportColumns-immer';
import React, { useLayoutEffect, useState } from 'react';

import { EAllowedConditionalTypes } from '../../../../createConditional/types';
import { IReportLocale } from '../../../../locale';
import styles from '../CreateConditionalModal.scss';

export interface ISecondConditionalStep {
  reportLocaleText: IReportLocale;
  ifColumnOptions: any;
  columns: IReportColumn[];
  conditional: IConditionalReportColumn<any>;
  handleValueSelect(value: any, updaterFunction: (arg0: any) => void): void;
  updateIfValue(column: IReportColumn): void;
}

export function Step2(props: ISecondConditionalStep) {
  const {
    ifColumnOptions,
    conditional,
    reportLocaleText: {
      calculations: {
        conditionalModal: { step2SelectPlaceholder, wordIf }
      }
    },
    updateIfValue
  } = props;
  const [maxHeight, setMaxHeight] = useState(0);

  useLayoutEffect(() => {
    function updateMaxHeight() {
      const listbox = document.querySelector('#step-2 [aria-haspopup="listbox"]');
      if (!listbox) return;
      const clientRect = listbox.getBoundingClientRect();
      const windowHeight = globalThis.innerHeight;
      const maxHeight = windowHeight - clientRect.bottom;
      setMaxHeight(maxHeight);
    }

    updateMaxHeight();

    globalThis.addEventListener('resize', updateMaxHeight);
    return () => {
      globalThis.removeEventListener('resize', updateMaxHeight);
    };
  }, []);

  return (
    <div id="step-2" className={styles.flexHorizontal}>
      <strong>{wordIf}</strong>
      <div className={styles.oneUnitSpacer} />
      <Select
        maxMenuHeight={maxHeight}
        value={conditional.sourceColumn.name}
        placeholder={step2SelectPlaceholder}
        dataTest="if-select-menu"
        onChange={(value) => {
          props.handleValueSelect(value, updateIfValue);
        }}
      >
        {[
          ...[...(Object as any).values(EAllowedConditionalTypes)].reduce((options, columnType) => {
            if (ifColumnOptions[columnType]) {
              if (options.length > 0) {
                options.push(<Select.Divider key={`show-option-${columnType}-divider`} />);
              }
              options.push([
                <Select.Label
                  key={`if-${columnType}-section-label`}
                  text={(columnType as string).toUpperCase()}
                  disabled={ifColumnOptions[columnType].disabled}
                />,
                ...ifColumnOptions[columnType].items.map((option, i) => {
                  return (
                    <Select.Option
                      disabled={option.disabled}
                      dataTest={`if-${columnType}-option-${i}`}
                      key={`if-option-${option.value}`}
                      label={option.label}
                      value={option.value}
                      secondaryLabel={option.secondaryLabel}
                    />
                  );
                })
              ]);
            }
            return options;
          }, [])
        ]}
      </Select>
    </div>
  );
}
